import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.show();
  }

  show() {
    this.element.inert = true;
    this.element.showModal();
    this.element.inert = false;
  }

  hide() {
    this.element.close();
  }

  back() {
    const backButton = document.getElementById('back-button');
    if (backButton) {
      document.getElementById('back-button').click();
    } else {
      this.element.close();
    }
  }
}
